import React from "react"
import { connect } from "react-redux"
import inputValidationColor from "./Input_Validation_Color"
import { isMobileDevice } from "functions"

const InputField = props => {
  const {
    formName,
    field,
    form,
    type,
    icon,
    className,
    viewMode,
    min,
    step,
    required,
    locale,
    messages
  } = props
  return (
    <div className="field">
      <label className="label is-small">
        <div className="heading has-text-grey">
          {messages.labels[formName][field.name][locale]}{" "}
          {required &&
            !viewMode &&
            `(${messages.labels.commonUse.required[locale]})`}
        </div>
      </label>
      <div className="control has-icons-left has-icons-right">
        <input
          {...field}
          type={type}
          placeholder={
            !isMobileDevice()
              ? messages.placeholders[formName][field.name][locale]
              : ""
          }
          readOnly={viewMode}
          className={
            viewMode
              ? className
              : `${className} ${inputValidationColor(
                  field.name,
                  form.touched,
                  form.errors
                )}`
          }
          min={min}
          step={step}
          lang="en-150"
          formNoValidate
        />
        <span className="icon is-small is-left">
          <i className={icon} />
        </span>
      </div>
    </div>
  )
}

const mapStateToProps = state => {
  return {
    messages: {
      labels: state.intl.messages.components.form.labels,
      placeholders: state.intl.messages.components.form.placeholders
    },
    locale: state.intl.locale
  }
}

export default connect(mapStateToProps)(InputField)
